// extracted by mini-css-extract-plugin
export default {"root":"applications-components-ProductsApp-components-RootMenu-departments-module__root","slider":"applications-components-ProductsApp-components-RootMenu-departments-module__slider","item":"applications-components-ProductsApp-components-RootMenu-departments-module__item","link":"applications-components-ProductsApp-components-RootMenu-departments-module__link","linkActive":"applications-components-ProductsApp-components-RootMenu-departments-module__linkActive"};
    if(module.hot) {
      // 1791528099476
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  